/**
 * Version des données locales (Dexie) par collection synchronisée.
 *
 * À quoi ça sert
 * --------------
 * La synchro est incrémentale (`$updatedAt > last_updated_<collection>`) : un document inchangé côté
 * AppWrite n'est jamais rechargé. Si le code change la façon dont un document est stocké en local
 * (nouveau champ mappé), les documents déjà présents sur les appareils restent donc sans ce champ.
 * Ce mécanisme force UN rechargement complet de la collection concernée, une seule fois par appareil.
 *
 * Quand incrémenter
 * -----------------
 * Ajout ou changement de mapping d'un champ dans un `build*Object` (ex. `buildCustomerObject`)
 * alors que la donnée EXISTE DÉJÀ côté AppWrite sur des documents non retouchés.
 *
 * Quand NE PAS incrémenter
 * ------------------------
 * Champ nouveau côté AppWrite ET documents retouchés à cette occasion : leur `$updatedAt` change,
 * la synchro incrémentale suffit.
 *
 * Comment brancher une nouvelle collection
 * ----------------------------------------
 * 1. Ajouter une entrée dans `LOCAL_DATA_VERSIONS` (ex. `orders: 2`).
 * 2. Dans son `fetch*` : lire `useSalesStore.getState().local_data_versions`, appeler
 *    `isLocalDataOutdated(stored, LOCAL_DATA_VERSIONS.<nom>)` ; si périmée, faire un fetch complet
 *    (comme `newLogin`) ; après un fetch RÉUSSI seulement (jamais dans un `.finally()`),
 *    appeler `setLocalDataVersion('<nom>', LOCAL_DATA_VERSIONS.<nom>)`.
 *    Modèle : `fetchCustomers` dans src/Contexts/AppWriteContext.tsx.
 *
 * Effet sur l'appareil
 * --------------------
 * Un rechargement complet unique de cette collection, au premier lancement de la nouvelle version.
 * Si le fetch échoue (hors ligne…), la version n'est pas enregistrée : il est retenté à la synchro suivante.
 *
 * Historique des incréments
 * -------------------------
 * - customers 1 → 2 : ajout du champ `shortname` (messika-pwa#43).
 */

export const LOCAL_DATA_VERSIONS: Record<string, number> = {
   customers: 2,
}

/** Une version absente vaut 1 (données chargées avant l'existence du mécanisme). */
export function isLocalDataOutdated(stored: number | null | undefined, current: number): boolean {
   return (stored ?? 1) < current
}
